import React, { Component } from "react";
import { Container, FormControl, Button, Row, Col } from "react-bootstrap";
import { UploadBatchBranchData } from "../../../../store/services/settings/settings_branch_target_service";

class InventoryTargetBatchUpload extends Component {
  state = {
    files: [],
    isLoading: false,
  };

  render() {
    return (
      <Container>
        <Row>
          <Col>
            <FormControl
              accept=".csv"
              type="file"
              className="m-2"
              files={this.state.files}
              onChange={(e) => {
                this.setState({ files: e.target.files });
              }}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <Button
              className="m-2"
              disabled={this.state.isLoading}
              onClick={() => {
                this.setState({ isLoading: true });
                UploadBatchBranchData({ file: this.state.files }).then((r) => {
                  this.setState({ isLoading: false });
                  this.props.onRefresh();
                });
              }}
            >
              {this.state.isLoading ? "Uploading" : "Start Upload"}
            </Button>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default InventoryTargetBatchUpload;
